import * as Sentry from '@sentry/browser';
import { DatadogRumClientInstance, SentryClientInstance, SentryOptions } from '../declarations';
import { RumInitConfiguration, datadogRum } from '@datadog/browser-rum';
import { getDeployEnv } from './deployEnv';
import { buildDefaultSentryOpts } from './sentry';

export const defaultInitSentry = (sentryOptions: SentryOptions): SentryClientInstance => {
  Sentry.init(sentryOptions);
  return Sentry.getCurrentHub();
};

export const defaultInitDatadogRumClient = (
  datadogInitOpts: RumInitConfiguration,
): DatadogRumClientInstance => {
  datadogRum.init({ ...datadogInitOpts });
  datadogRum.startSessionReplayRecording();
  return datadogRum;
};

/**
 * TODO:
 * This is kept for backwards compatibility. We should let observability lib handle Sentry initialization,
 * which might require us to build a version of observability for non-consumer apps.
 */
export const loadSentry = (url: string, sentryOptions: Sentry.BrowserOptions = {}) => {
  const env = getDeployEnv();
  const gitSha = process.env.REACT_APP_GIT_SHA || 'unknown';
  defaultInitSentry({
    ...buildDefaultSentryOpts({ appName: '', env, version: gitSha }),
    ...sentryOptions,
    dsn: url,
  });
};

// Export Sentry directly here so that existing behavior is maintained
// eventually we want to use the "globalObservability.getSentryClient()" proxy
// instance here
export { Sentry };
